import * as t from 'io-ts';

export const LoyaltyTermsAndConditionsMetaDataDynamicType = t.interface({
    read: t.boolean
});

export type LoyaltyTermsAndConditionsMetaData = t.TypeOf<typeof LoyaltyTermsAndConditionsMetaDataDynamicType>;
